import { GlameraIconSize } from './types';

/** Matches the reference heart animation (`duration = 1` second). */
export const GLAMERA_DEFAULT_DURATION = 1000;

/** Accepts `24`, `"24"`, or CSS units like `"2rem"`. */
export function coerceIconSize(size: GlameraIconSize): string {
  if (typeof size === 'number' && Number.isFinite(size)) {
    return `${size}px`;
  }

  const value = String(size).trim();
  if (/^\d+(\.\d+)?$/.test(value)) {
    return `${value}px`;
  }

  return value || '24px';
}

export function coerceDurationMs(value: number | string): number {
  const parsed = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(parsed) || parsed < 0) {
    return GLAMERA_DEFAULT_DURATION;
  }
  return parsed;
}

export function coerceBooleanAttribute(value: boolean | string | null | undefined): boolean {
  return value === '' || value === true || value === 'true';
}
